import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => {
	return [
		{ title: 'Privacy Policy | Axiom' },
		{ name: 'description', content: 'Privacy policy and data handling practices for Axiom' },
	]
}

export default function PrivacyRoute() {
	return (
		<div className="container mx-auto max-w-4xl px-6 py-12 min-h-screen">
			<div className="space-y-8">
				<div className="flex flex-col gap-2">
					<h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
						Privacy Policy
					</h1>
					<p className="text-lg text-gray-600 dark:text-gray-400">
						How we collect and protect your data
					</p>
				</div>

				<section className="prose prose-invert prose-lg max-w-none prose-headings:font-semibold prose-headings:tracking-tight prose-lead:text-gray-400 prose-p:text-gray-300">
					<p className="lead text-xl">
						Last updated: {new Date().toLocaleDateString('en-US', {
							month: 'long',
							day: 'numeric',
							year: 'numeric',
						})}
					</p>

					<h2 className="text-2xl mt-12 mb-4">Introduction</h2>
					<p>
						Your privacy is important to us. This Privacy Policy explains how we collect,
						use, and protect your personal information when you use Axiom.
					</p>

					<h2 className="text-2xl mt-12 mb-4">Information We Collect</h2>
					<ul>
						<li>Account information (email, name)</li>
						<li>Content you create</li>
						<li>Usage data and analytics</li>
						<li>Device and browser information</li>
					</ul>

					<h2 className="text-2xl mt-12 mb-4">How We Use Your Information</h2>
					<p>We use your information to:</p>
					<ul>
						<li>Provide and improve our services</li>
						<li>Personalize your experience</li>
						<li>Communicate with you about your account</li>
						<li>Ensure security and prevent fraud</li>
					</ul>

					<h2 className="text-2xl mt-12 mb-4">Data Security</h2>
					<p>
						We implement appropriate security measures to protect your personal
						information.
					</p>

					<h2 className="text-2xl mt-12 mb-4">Your Rights</h2>
					<p>You have the right to:</p>
					<ul>
						<li>Access your personal data</li>
						<li>Correct inaccurate data</li>
						<li>Request deletion of your data</li>
						<li>Request an export of your data</li>
					</ul>

					<h2 className="text-2xl mt-12 mb-4">Contact Us</h2>
					<p className="mb-8">
						If you have any questions about this Privacy Policy, please contact us at{' '}
						<a href="mailto:support@axiom.industries" className="text-blue-400 hover:text-blue-300 underline">
							support@axiom.industries
						</a>
					</p>
				</section>
			</div>
		</div>
	)
}
